'use strict';

import angular from 'angular';
import UpdatedCountController from './count.controller';

export default angular.module('updateServerApp.firmwares.updatedCount', [])
  .controller('FirmwaresUpdatedCountController', UpdatedCountController)
  .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/count/index.js